export const AppHelper = {
  humanizeSnakeCase: (key: string): string =>
    key
      .trim()
      .split(/[_\s]+/) // split by both _ and whitespaces
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' '),

  stripProtocol: (url: string): string => url.replace(/^https?:\/\//, ''),

  addProtocol: (url: string): string => {
    if (!url) return url;
    if (url.match(/^[a-z][a-z0-9+.-]*:\/\//i)) {
      return url;
    }
    return `https://${url}`;
  },
};
